// ================ Action types ================ //

export const DISABLE_SCROLLING = 'app/ui/DISABLE_SCROLLING';
export const SWITCH_LANGUAGE = 'app/ui/SWITCH_LANGUAGE';

// ================ Reducer ================ //

// Initialize language from sessionStorage if available, otherwise default to Swedish
const getInitialLanguage = () => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    const savedLanguage = window.sessionStorage.getItem('sessionLanguage');
    if (savedLanguage) {
      return savedLanguage;
    }
  }
  return 'sv'; // Default to Swedish for sharegardens
};

const initialState = {
  disableScrollRequests: [],
  language: getInitialLanguage(),
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case DISABLE_SCROLLING: {
      const { componentId, disableScrolling } = payload;
      const disableScrollRequests = state.disableScrollRequests;
      const componentIdExists = disableScrollRequests.find(c => c.componentId === componentId);

      if (componentIdExists) {
        const disableScrollRequestArray = disableScrollRequests.map(c => {
          return c.componentId === componentId ? { ...c, disableScrolling } : c;
        });
        return { ...state, disableScrollRequests: [...disableScrollRequestArray] };
      }

      const disableScrollRequestArray = [
        ...disableScrollRequests,
        { componentId, disableScrolling },
      ];
      return {
        ...state,
        disableScrollRequests: disableScrollRequestArray,
      };
    }

    case SWITCH_LANGUAGE:
      return { ...state, language: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const manageDisableScrolling = (componentId, disableScrolling) => ({
  type: DISABLE_SCROLLING,
  payload: { componentId, disableScrolling },
});

export const switchLanguage = newLanguage => ({ type: SWITCH_LANGUAGE, payload: newLanguage });

export const handleSwitchLanguage = newLanguage => (dispatch, getState, sdk) => {
  dispatch(switchLanguage(newLanguage));

  // Persist language preference to user profile if authenticated
  const state = getState();
  const { currentUser } = state.user;
  const isAuthenticated = state.auth.isAuthenticated;

  if (isAuthenticated && currentUser?.id) {
    const existingProtected = currentUser.attributes?.profile?.protectedData || {};
    const updatedProtected = { ...existingProtected, language: newLanguage };
    
    sdk.currentUser
      .updateProfile({ protectedData: updatedProtected })
      .then(() => {
        // Refetch current user to update store
        if (typeof sdk.currentUser.show === 'function') {
          return sdk.currentUser.show({ include: ['profileImage'] });
        }
        return null;
      })
      .catch(e => {
        console.error('Failed to persist language preference:', e);
      });
  }
};

// ================ Selectors ================ //

export const isScrollingDisabled = state => {
  const { disableScrollRequests } = state.ui;
  return disableScrollRequests.some(r => r.disableScrolling);
};
